import { Grid } from '@mui/material'
import CANOwnershipDetailsCard from './CANOwnershipDetailsCard'
import MichiganTitleApplicationPacketCard from './MichiganTitleApplicationPacketCard'
import { useEffect, useState } from 'react'
import { getTitle } from 'controllers/vehicles'
import { VehicleTitleDto } from 'dtos/vehicles/titles'
import { values } from 'lodash'
import OhioTitleApplicationPacketCard from './OhioTitleApplicationPacketCard'

interface Props {
  vehicleGuid?: string
}

export default function TitleTab({ vehicleGuid }: Props) {
  const [state, setState] = useState<VehicleTitleDto | undefined>(undefined)
  const [isLoading, setIsLoading] = useState<boolean>(false)

  useEffect(() => {
    if (!vehicleGuid) return

    setIsLoading(true)
    getTitle(vehicleGuid)
      .then(res => setState(res.value))
      .finally(() => setIsLoading(false))
  }, [vehicleGuid])

  return (
    <Grid item xs={12} container alignItems='flex-start'>
      <Grid item sm={12} md={4}>
        <CANOwnershipDetailsCard isLoading={isLoading} values={state?.canOwnership} />
      </Grid>

      {!isLoading && state?.michiganTitleApplicationPacket && (
        <Grid item sm={12} md={8}>
          <MichiganTitleApplicationPacketCard values={state.michiganTitleApplicationPacket} />
        </Grid>
      )}

      {!isLoading && state?.ohioTitleApplicationPacket && (
        <Grid item sm={12} md={8}>
          <OhioTitleApplicationPacketCard values={state.ohioTitleApplicationPacket} />
        </Grid>
      )}
    </Grid>
  )
}
